module.exports = {"title":"Pronto! A gente já salvou suas alterações ;)","currency":"R$","buttonLabel":"Sim","button":"Voltar","titleModalError":"Ops.","descriptionModalError":"Recarga não autorizada. Consulte seu cartão ou tente novamente com outro cartão de crédito.","awaitUpdate":"Dentro de alguns segundos o saldo da sua conta estará atualizado."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/editPaymentSuccess/data.json
// module id = 2208
// module chunks = 0